// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1AMoG","title":"Info_title__27Fw5","links":"Info_links__1P08p","link":"Info_link__3MFsd","logo":"Info_logo__qIrTU"};